import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM12 7C12.5523 7 13 7.44772 13 8V11H16.0005C16.5528 11 17.0005 11.4477 17.0005 12C17.0005 12.5523 16.5528 13 16.0005 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8.00049C7.4482 13 7.00049 12.5523 7.00049 12C7.00049 11.4477 7.4482 11 8.00049 11H11V8C11 7.44772 11.4477 7 12 7Z"
    />
  </svg>
);

const PlusSquareIcon = (props) => <Icon component={SVG} {...props} />;

export default PlusSquareIcon;
